// Copyright (c) 2026 Otyka LLC. All rights reserved.

import React from 'react';
import './NarrativeSummary.css';

export default function NarrativeSummary({ narrative, loading }) {
  if (loading) {
    return (
      <div className="narrative narrative--loading" aria-busy="true" aria-label="Loading narrative summary">
        <div className="narrative__skeleton-line narrative__skeleton-line--wide" />
        <div className="narrative__skeleton-line" />
        <div className="narrative__skeleton-line narrative__skeleton-line--wide" />
        <div className="narrative__skeleton-line narrative__skeleton-line--short" />
        <div className="narrative__skeleton-gap" />
        <div className="narrative__skeleton-line narrative__skeleton-line--wide" />
        <div className="narrative__skeleton-line" />
        <div className="narrative__skeleton-line narrative__skeleton-line--short" />
      </div>
    );
  }

  if (!narrative || !narrative.paragraphs?.length) return null;

  return (
    <div className="narrative" aria-label="AI-generated member feedback summary">
      <div className="narrative__header">
        <span className="narrative__label">Executive Summary</span>
        <span className="narrative__badge" aria-label="Generated by AI">✦ AI</span>
      </div>
      <div className="narrative__body">
        {narrative.paragraphs.map((para, i) => (
          <p key={i} className="narrative__para">{para}</p>
        ))}
      </div>
    </div>
  );
}
